import LayoutGiveaway from "components/layouts/LayoutGiveaway";
import Link from "next/link";
import Meta from "solar/components/Meta";
import Photo from "components/shared/stays/Photo";
import Title from "components/shared/stays/Title";
import Lead from "components/shared/stays/Lead";
import Button from "solar/components/Button";
import Divider from "components/shared/stays/Divider";
import Hero from "components/narrative/Hero";
import Section from "components/narrative/Section";
import Body from "components/giveaways/Body";
import EmailSignup from "components/giveaways/EmailSignup";
import SocialButton from "components/giveaways/SocialButton";
import Trips from "components/giveaways/Trips";
import SideBySide from "components/giveaways/SideBySide";
import SideBySideRow from "components/giveaways/SideBySideRow";

import photo01 from "public/giveaways/pursuit-01.jpg";
import photo02 from "public/giveaways/pursuit-02.jpg";
import photo03 from "public/giveaways/pursuit-03.jpg";
import photo04 from "public/giveaways/pursuit-04.jpg";

export default function Giveaway() {
  const tripData = [
    {
      key: "9991",
      id: 410,
      name: "Bungalows Punta Conejo",
      slug: "bungalows-punta-conejo",
      country: "Mexico",
      lowest_price_per_person_per_night: 186,
      lowest_product_pricing_type: "per_person_per_night",
      trip_type_description: "Lodge",
      is_featured: false,
      main_image: {
        url: "https://d26bypd28u84x1.cloudfront.net/ugmtjbf4wto7rgki0pvfbfo466hl",
        content_type: "image/jpeg",
        byte_size: 133608,
        width: 1280,
        height: 960,
      },
    },
    {
      key: "9992",
      id: 397,
      name: "Tahurai Homestay Teahupo'o",
      slug: "tahurai-homestay-teahupo-o",
      is_visible: true,
      country: "French Polynesia",
      lowest_price_per_person_per_night: 65,
      lowest_product_pricing_type: "per_person_per_night",
      trip_type_description: "Lodge",
      is_featured: false,
      main_image: {
        url: "https://d26bypd28u84x1.cloudfront.net/3kb7arrgb4k6nibs7zne2onfjdl0",
        content_type: "image/jpeg",
        byte_size: 567652,
        width: 2000,
        height: 1333,
      },
    },
    {
      key: "9993",
      id: 504,
      name: "Awera Resort",
      slug: "awera-resort",
      country: "Indonesia",
      lowest_price_per_person_per_night: 350,
      lowest_product_pricing_type: "per_night",
      trip_type_description: "Lodge",
      is_featured: false,
      main_image: {
        url: "https://d26bypd28u84x1.cloudfront.net/pgolbws6oeevczkckmtscs11eh2f",
        content_type: "image/jpeg",
        byte_size: 3154528,
        width: 3840,
        height: 2558,
      },
    },
    {
      key: "9994",
      id: 473,
      name: "Kaini Mentawais",
      slug: "kaini-mentawais",
      country: "Indonesia",
      lowest_price_per_person_per_night: 230,
      lowest_product_pricing_type: "per_person_per_night",
      trip_type_description: "Lodge",
      is_featured: false,
      main_image: {
        url: "https://d26bypd28u84x1.cloudfront.net/a4md5rztkybuhhldvfiy78r86g2o",
        content_type: "image/jpeg",
        byte_size: 415401,
        width: 1500,
        height: 1126,
      },
    },
  ];

  return (
    <>
      <Meta
        title="Pursuit Surf Travel Giveaway"
        description="We’re giving away $3,000 in Thermal travel credit, plus a 6-month supply of Pursuit skincare products to ensure your skin is protected every time you paddle out."
        path="/giveaways/pursuit"
        imageOgUrl="https://www.thermal.travel/meta/pursuit-og.jpg"
        imageTwitterUrl="https://www.thermal.travel/meta/pursuit-og.jpg"
        imageType="image/jpeg"
      />
      <Hero>
        <Photo
          imageBlurSrc={photo01.blurDataURL}
          src={photo01.src}
          alt="Pursuit Surf Travel Giveaway"
          layout="fill"
          objectFit="cover"
          placeholder
          priority
        />
      </Hero>

      <Body>
        <Section>
          <Title size={2} tag="h1" font="cushing">
            Win $3k Thermal Travel Credit + a Pursuit Skincare Supply!
          </Title>
          <Lead>
            Sunscreen and surf — two things that go hand-in-hand. Which is why
            we have teamed up with Pursuit and Pro Surfer Alana Blanchard to
            give away the surf trip of your life! Score $3,000 in Thermal travel
            credit — to spend on your choice of any Thermal surf trip! Plus, win
            a 6-month supply of Pursuit skincare products to ensure your skin is
            protected every time you paddle out. Follow the steps below to
            enter. Winner will be notified by email and annouced on Instagram on
            December 14th 2022. Good luck!
          </Lead>
          <div
            style={{
              color: "#ff4f00",
              fontStyle: "italic",
              maxWidth: "70%",
              marginLeft: "auto",
              marginRight: "auto",
            }}
          >
            <Title size={5} tag="h2">
              competition closed, lucky winner will be notified via email and on
              our Instagram @thermal.travel
            </Title>
          </div>
        </Section>
        <Divider />

        <Section>
          <Title size={3} tag="h2" font="cushing">
            Step 1
          </Title>
          <Lead>Sign up below for Thermal&apos;s newsletter.</Lead>
          <EmailSignup
            formLocation="Pursuit"
            subscribeEvent="pursuit-giveaway"
            giveawayName="Pursuit"
          />
        </Section>
        <Divider />

        <Section>
          <Title size={3} tag="h2" font="cushing">
            Step 2
          </Title>
          <Lead>
            Follow Pursuit, Alana, and Thermal on Instagram.
            <br />
            Here’s where you can find us:
          </Lead>
          <div>
            <SocialButton
              url="https://www.instagram.com/pursuitbeauty/"
              text="@pursuitbeauty"
            />
            <SocialButton
              url="https://www.instagram.com/alanarblanchard/"
              text="@alanarblanchard"
            />
            <SocialButton
              url="https://www.instagram.com/thermal.travel/"
              text="@thermal.travel"
            />
          </div>
        </Section>
        <Divider />

        <Section>
          <SideBySide>
            <SideBySideRow photo={photo02} headline="Another chance to win...">
              <div>
                Share{" "}
                <a
                  href="https://www.instagram.com/p/ClUxrKgDd26/"
                  alt="Pursuit giveaway post on Instagram"
                  rel="noopener noreferrer"
                  target="_blank"
                >
                  our post
                </a>{" "}
                to your Instagram stories and tag @thermal.travel and
                @pursuitbeauty to double your odds of winning a free trip.
              </div>
            </SideBySideRow>
            <SideBySideRow
              photo={photo03}
              isReversed
              isQuote
              quoteAttribution="Alana Blanchard"
            >
              <div>
                Going on an amazing surf trip with your friends and family is
                truely one of the best things you can do.
              </div>
            </SideBySideRow>
            <SideBySideRow photo={photo04} headline="The prize">
              <div>
                The winner will receive $3,000 in travel credit to spend on any
                surf trip offered by Thermal + a 6 month supply of Pursuit
                skincare.
              </div>
            </SideBySideRow>
          </SideBySide>
        </Section>

        <Divider />

        <Section>
          <Title size={3} tag="h2" font="cushing">
            Rules
          </Title>
          <Lead>
            The giveaway will close at 11:59 PM PDT, December 13st, 2022. The
            winner will be randomly selected and announced December 14th, 2022
            via Instagram. Open to anyone 18+ years of age. See all giveaway
            terms &amp; conditions{" "}
            <a
              href="https://withthermal.notion.site/Thermal-Pursuit-Giveaway-Terms-Conditions-d750fca0d8ce447fba906ea408b94fca"
              rel="noopener noreferrer"
              target="_blank"
              alt="Giveaway terms and conditions"
            >
              here
            </a>
            .
          </Lead>
        </Section>
        <Divider />
        <Section>
          <Title size={3} tag="h2" font="cushing">
            Alana&rsquo;s favorite trips
          </Title>

          <Trips trips={tripData} />

          <Link href="/stays/" prefetch={false}>
            <a alt="Explore surf trips" target="_blank">
              <Button>Discover more surf trips</Button>
            </a>
          </Link>
        </Section>
      </Body>
    </>
  );
}

Giveaway.Layout = LayoutGiveaway;
